import getPointerSelfPosition from "./get-pointer-self-position";

/**
 *
 * @param {Number} difference
 * @param {BoundsProps} bounds
 * @param {Number} pointer
 * @param {Number | null} threshold
 * @param {Number} type
 * @returns
 */
const getPointerSelfPercentsY = (difference, bounds, pointer, threshold, type) => {
  if (difference < 0) {
    return getPointerSelfPosition(
      bounds,
      pointer,
      "height",
      "top",
      threshold,
      false,
      type
    );
  } else {
    return getPointerSelfPosition(
      bounds,
      pointer,
      "height",
      "bottom",
      threshold,
      true,
      type
    );
  }
};

export default getPointerSelfPercentsY;
